export default "__VITE_ASSET__BrXDHnok__"